import { useEffect, useMemo, useState } from "react";
import "./transaction.css";

const fmt = (n) => new Intl.NumberFormat("es-PA", { style: "currency", currency: "USD" }).format(Number(n) || 0);
const fmtN = (n) => new Intl.NumberFormat("es-PA").format(Number(n) || 0);
const now = () => {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
};

const I = {
  Search: ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>,
  Refresh: ({ s = 15 }) => <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="23 4 23 10 17 10" /><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" /></svg>,
  ChevDown: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="6 9 12 15 18 9" /></svg>,
  ChevLeft: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="15 18 9 12 15 6" /></svg>,
  ChevRight: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="9 18 15 12 9 6" /></svg>,
  Store: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
  CreditCard: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></svg>,
  DollarSign: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>,
  TrendUp: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>,
  ArrowDownLeft: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="17" y1="7" x2="7" y2="17" /><polyline points="17 17 7 17 7 7" /></svg>,
  Clock: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
  Activity: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12" /></svg>,
  Download: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>,
  Check: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12" /></svg>,
  XCircle: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>,
  RotateCcw: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" /></svg>,
  SortAsc: () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="18 15 12 9 6 15" /></svg>,
  SortDesc: () => <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9" /></svg>,
};

const getDate = (order) => {
  const raw = order?.createdAt || order?.created_at || order?.updatedAt;
  const date = raw ? new Date(raw) : new Date();
  return Number.isNaN(date.getTime()) ? new Date() : date;
};

const getTime = (order) => {
  const date = getDate(order);
  return `${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
};

const getBranchCode = (order) => order?.branchoffice?.code ?? order?.branchoffice_code ?? order?.branch_code ?? "";
const getBranchName = (order) => order?.branchoffice?.branchoffice_name || order?.branchoffice?.name || order?.branch_name || "Sucursal";
const getCustomerName = (order) => order?.client_name || order?.customer_name || order?.client?.name || order?.beneficiary?.client_name || "Consumidor final";
const getMethod = (order) => order?.paymenthod || order?.payment_method || order?.paymentMethod || "Sin metodo";
const getAmount = (order) => Number(order?.total ?? order?.amount ?? 0) || 0;
const getTxnId = (order) => order?.transaction_code || order?.code || order?.order_id || order?._id || "-";
const getTempCode = (order) => order?.code || order?.order_code || order?.temp_order_code || order?.temporal_order_code || order?.transaction_code || "";
const getItems = (order) => {
  const groups = Array.isArray(order?.groups) ? order.groups : [];
  const combos = Array.isArray(order?.combos) ? order.combos : [];
  const direct = Number(order?.items_count || order?.items || 0);
  const count = [...groups, ...combos].reduce((sum, item) => sum + (Number(item?.amount || item?.quantity || item?.qty || 1) || 0), 0);
  return count || direct || 0;
};

const getStatus = (order) => {
  if (order?.status?.name) return order.status.name;
  if (order?.status_name) return order.status_name;
  if ([1, 2, 3].includes(Number(order?.status_id))) return "Pendiente";
  if ([6, 8, 9].includes(Number(order?.status_id))) return "Rechazada";
  return "Aprobada";
};

const getRequestType = (order) => {
  const explicitType = order?._approval_request_type || order?.request_type || order?.notification_type;
  if (String(explicitType).toLowerCase().includes("devol")) return "Devolucion";
  if (String(explicitType).toLowerCase().includes("discount") || String(explicitType).toLowerCase().includes("descuento")) return "Descuento";
  if (order?.is_devolution_notification === true) return "Devolucion";
  if (order?.is_discount_notification === true) return "Descuento";
  if (order?.order_type === "devolution" || order?.invoice_type === "devolution") return "Devolucion";
  if (Number(order?.discount || 0) > 0 || Number(order?.unit_discount || 0) > 0 || (Array.isArray(order?.discounts) && order.discounts.length > 0)) return "Descuento";
  return "Descuento";
};

const isOpenRequest = (order) => {
  const rawStatus = order?.status_id ?? order?.status?.id ?? order?.status?.name ?? order?.status_name;
  if (rawStatus === undefined || rawStatus === null || rawStatus === "") return true;
  if (Number(rawStatus) === 1) return true;

  const statusText = String(rawStatus).toLowerCase();
  return ["pendiente", "pending", "abierta", "open"].some((status) => statusText.includes(status));
};

const normalizeBranch = (branch) => ({
  code: branch?.code ?? branch?.branchoffice_code ?? 0,
  name: branch?.branchoffice_name || branch?.name || "Sucursal",
});

export default function TransactionsPanel({
  transactions = [],
  returns = [],
  branches = [],
  selectedBranchCode = 0,
  dataBranchoffice = 0,
  pedidosYaStatus = "CLOSED",
  uberEatsStatus = "OFFLINE",
  showPedidosYa = false,
  showUberEats = false,
  onSelectBranch,
  onRefreshTransactions,
  onRefreshReturns,
  onOpenTransaction,
  onOpenReturn,
  onToggleBranchStatus,
  onTogglePedidosYa,
  onToggleUberEats,
}) {
  const [branchDD, setBranchDD] = useState(false);
  const [lastRefresh, setLastRefresh] = useState(now());
  const [tSearch, setTSearch] = useState("");
  const [tStatus, setTStatus] = useState("Todos");
  const [tMethod, setTMethod] = useState("Todos");
  const [rpp, setRpp] = useState(10);
  const [page, setPage] = useState(1);
  const [sKey, setSKey] = useState(null);
  const [sDir, setSDir] = useState("desc");
  const [rSearch, setRSearch] = useState("");
  const [rType, setRType] = useState("Todos");

  const branchOptions = useMemo(() => [{ code: 0, name: "Todas las sucursales" }, ...branches.map(normalizeBranch)], [branches]);
  const selectedBranch = branchOptions.find((branch) => String(branch.code) === String(selectedBranchCode)) || branchOptions[0];
  const openReturns = useMemo(() => returns.filter(isOpenRequest), [returns]);
  const methods = useMemo(() => Array.from(new Set(transactions.map(getMethod).filter(Boolean))), [transactions]);
  const isBranchOpen = dataBranchoffice !== 0 && Number(dataBranchoffice?.branchoffice_open) === 1;

  const filteredTxn = useMemo(() => {
    let data = [...transactions];
    if (String(selectedBranchCode) !== "0") data = data.filter((order) => String(getBranchCode(order)) === String(selectedBranchCode));
    if (tStatus !== "Todos") data = data.filter((order) => getStatus(order) === tStatus);
    if (tMethod !== "Todos") data = data.filter((order) => getMethod(order) === tMethod);
    if (tSearch.trim()) {
      const q = tSearch.toLowerCase();
      data = data.filter((order) => [
        getTxnId(order),
        getCustomerName(order),
        getMethod(order),
        getBranchName(order),
      ].some((value) => String(value).toLowerCase().includes(q)));
    }
    if (sKey) {
      data.sort((a, b) => {
        const value = (order) => ({
          time: getDate(order).getTime(),
          id: String(getTxnId(order)),
          customer: getCustomerName(order),
          method: getMethod(order),
          items: getItems(order),
          amount: getAmount(order),
          status: getStatus(order),
        })[sKey];
        const av = value(a);
        const bv = value(b);
        if (typeof av === "number") return sDir === "asc" ? av - bv : bv - av;
        return sDir === "asc" ? String(av).localeCompare(String(bv)) : String(bv).localeCompare(String(av));
      });
    }
    return data;
  }, [transactions, selectedBranchCode, tStatus, tMethod, tSearch, sKey, sDir]);

  const filteredRet = useMemo(() => {
    let data = [...openReturns];
    if (String(selectedBranchCode) !== "0") data = data.filter((order) => String(getBranchCode(order)) === String(selectedBranchCode));
    if (rType !== "Todos") data = data.filter((order) => getRequestType(order) === rType);
    if (rSearch.trim()) {
      const q = rSearch.toLowerCase();
      data = data.filter((order) => [
        getTxnId(order),
        getTempCode(order),
        getCustomerName(order),
        getRequestType(order),
        getBranchName(order),
        order?.machine_code,
        order?.machine_name,
      ].some((value) => String(value || "").toLowerCase().includes(q)));
    }
    return data;
  }, [openReturns, selectedBranchCode, rType, rSearch]);

  const totalPages = Math.max(1, Math.ceil(filteredTxn.length / rpp));
  const pageData = filteredTxn.slice((page - 1) * rpp, page * rpp);
  const totalApproved = filteredTxn.filter((order) => getStatus(order) === "Aprobada").reduce((sum, order) => sum + getAmount(order), 0);
  const totalReturns = filteredRet.reduce((sum, order) => sum + getAmount(order), 0);
  const approvedCount = filteredTxn.filter((order) => getStatus(order) === "Aprobada").length;
  const avgTicket = approvedCount ? totalApproved / approvedCount : 0;

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const refresh = () => {
    setLastRefresh(now());
    onRefreshTransactions?.();
    onRefreshReturns?.();
  };

  const sort = (key) => {
    if (sKey === key) setSDir((dir) => dir === "asc" ? "desc" : "asc");
    else {
      setSKey(key);
      setSDir("desc");
    }
    setPage(1);
  };

  const pageNumbers = () => {
    const pages = [];
    const max = 5;
    let start = Math.max(1, page - Math.floor(max / 2));
    let end = Math.min(totalPages, start + max - 1);
    if (end - start < max - 1) start = Math.max(1, end - max + 1);
    if (start > 1) {
      pages.push(1);
      if (start > 2) pages.push("...");
    }
    for (let i = start; i <= end; i += 1) pages.push(i);
    if (end < totalPages) {
      if (end < totalPages - 1) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  const statusBadge = (status) => (
    <span className={`ts-badge ${status === "Aprobada" ? "ts-badge--success" : status === "Pendiente" ? "ts-badge--warning" : "ts-badge--danger"}`}>
      {status === "Aprobada" ? <I.Check /> : status === "Pendiente" ? <I.Clock /> : <I.XCircle />} {status}
    </span>
  );

  const requestBadge = (type) => (
    <span className={`ts-badge ${type === "Devolucion" ? "ts-badge--warning" : "ts-badge--blue"}`} style={{ marginLeft: 8 }}>
      {type}
    </span>
  );

  return (
    <div className="ts-root">
      <div className="ts-container">
        <div className="ts-top">
          <div className="ts-top__left">
            <div>
              <div className="ts-top__title">Transacciones en SmartPay</div>
              <div className="ts-top__sub"><I.Clock /> {lastRefresh} · Transacciones diarias en tiempo real</div>
            </div>
          </div>
          <div className="ts-top__right">
            <div className="ts-live"><div className="ts-live__dot" /> En vivo</div>
            {dataBranchoffice !== 0 && (
              <button className={`ts-status-pill ${isBranchOpen ? "ts-status-pill--open" : "ts-status-pill--closed"}`} onClick={onToggleBranchStatus} type="button">
                {isBranchOpen ? "Abierto" : "Cerrado"}
              </button>
            )}
            {showPedidosYa && dataBranchoffice !== 0 && (
              <button className={`ts-status-pill ${pedidosYaStatus === "OPEN" ? "ts-status-pill--open" : "ts-status-pill--closed"}`} onClick={onTogglePedidosYa} type="button">
                PedidosYa {pedidosYaStatus === "OPEN" ? "Abierto" : "Cerrado"}
              </button>
            )}
            {showUberEats && dataBranchoffice !== 0 && (
              <button className={`ts-status-pill ${uberEatsStatus === "ONLINE" ? "ts-status-pill--open" : "ts-status-pill--closed"}`} onClick={() => onToggleUberEats?.(uberEatsStatus === "ONLINE" ? "OFFLINE" : "ONLINE")} type="button">
                UberEats {uberEatsStatus === "ONLINE" ? "Online" : "Offline"}
              </button>
            )}
            <div style={{ position: "relative" }}>
              <button className="ts-btn-s" onClick={() => setBranchDD(!branchDD)} type="button"><I.Store /> {selectedBranch?.code === 0 ? "Sucursal" : selectedBranch?.name} <I.ChevDown /></button>
              {branchDD && (
                <>
                  <div style={{ position: "fixed", inset: 0, zIndex: 99 }} onClick={() => setBranchDD(false)} />
                  <div className="ts-dd">
                    {branchOptions.map((branch) => (
                      <button
                        key={branch.code}
                        className={`ts-dd__item ${String(selectedBranchCode) === String(branch.code) ? "ts-dd__item--active" : ""}`}
                        onClick={() => {
                          onSelectBranch?.(branch.code, branch);
                          setBranchDD(false);
                          setPage(1);
                        }}
                        type="button"
                      >
                        <I.Store /> {branch.name}
                        {String(selectedBranchCode) === String(branch.code) && <span style={{ marginLeft: "auto" }}><I.Check /></span>}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
            <button className="ts-btn-icon" onClick={refresh} type="button" title="Actualizar"><I.Refresh /></button>
            <button className="ts-btn-icon" type="button" title="Exportar"><I.Download /></button>
          </div>
        </div>

        <div className="ts-cards">
          {[
            { label: "Ventas aprobadas", value: fmt(totalApproved), icon: <I.DollarSign />, color: "#1B8C1B" },
            { label: "Transacciones", value: fmtN(filteredTxn.length), icon: <I.Activity />, color: "#5B5BD6" },
            { label: "Ticket promedio", value: fmt(avgTicket), icon: <I.TrendUp />, color: "#D97706" },
            { label: "Desc./Devoluciones", value: fmt(totalReturns), icon: <I.ArrowDownLeft />, color: "#C53030" },
          ].map((card, index) => (
            <div key={card.label} className="ts-card" style={{ animationDelay: `${index * 0.06}s` }}>
              <div className="ts-card__icon" style={{ background: `${card.color}12`, color: card.color }}>{card.icon}</div>
              <div>
                <div className="ts-card__label">{card.label}</div>
                <div className="ts-card__value">{card.value}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="ts-cols">
          <div className="ts-section">
            <div className="ts-section__head">
              <div className="ts-section__title"><I.CreditCard /> Historial de Transacciones</div>
              <div className="ts-section__actions">
                <span style={{ fontSize: 12, color: "#9090A0" }}>Filas</span>
                <div className="ts-rpp-group">
                  {[5, 10, 20].map((n) => <button key={n} className={`ts-rpp-btn ${rpp === n ? "ts-rpp-btn--active" : ""}`} onClick={() => { setRpp(n); setPage(1); }} type="button">{n}</button>)}
                </div>
              </div>
            </div>
            <div className="ts-filter-row">
              <div className="ts-search-wrap">
                <div className="ts-search-icon"><I.Search s={13} /></div>
                <input className="ts-search-input" placeholder="Buscar ID, cliente..." value={tSearch} onChange={(e) => { setTSearch(e.target.value); setPage(1); }} />
              </div>
              <select className="ts-filter-select" value={tStatus} onChange={(e) => { setTStatus(e.target.value); setPage(1); }}>
                <option>Todos</option>
                <option>Aprobada</option>
                <option>Pendiente</option>
                <option>Rechazada</option>
              </select>
              <select className="ts-filter-select" value={tMethod} onChange={(e) => { setTMethod(e.target.value); setPage(1); }}>
                <option>Todos</option>
                {methods.map((method) => <option key={method}>{method}</option>)}
              </select>
            </div>
            <div className="ts-table-wrap">
              <table className="ts-table">
                <thead>
                  <tr>
                    {[
                      { key: "time", label: "Hora", width: 70 },
                      { key: "id", label: "ID", width: 130 },
                      { key: "customer", label: "Cliente" },
                      { key: "method", label: "Metodo", width: 140 },
                      { key: "items", label: "Items", width: 60, align: "right" },
                      { key: "amount", label: "Monto", width: 100, align: "right" },
                      { key: "status", label: "Estado", width: 120 },
                    ].map((col) => (
                      <th key={col.key} style={{ width: col.width || "auto", textAlign: col.align || "left" }} onClick={() => sort(col.key)}>
                        <div className={`ts-th-content ${col.align === "right" ? "ts-th-content--right" : ""}`}>
                          {col.label}{sKey === col.key ? (sDir === "asc" ? <I.SortAsc /> : <I.SortDesc />) : <span style={{ width: 11 }} />}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {pageData.length === 0 ? (
                    <tr><td colSpan={7}><div className="ts-empty"><div className="ts-empty__icon"><I.CreditCard /></div><div className="ts-empty__title">Sin transacciones</div><div className="ts-empty__desc">No hay resultados</div></div></td></tr>
                  ) : pageData.map((order) => (
                    <tr key={order?._id || getTxnId(order)} onClick={() => onOpenTransaction?.(order)}>
                      <td style={{ color: "#9090A0", fontSize: 12 }}>{getTime(order)}</td>
                      <td style={{ fontWeight: 600, fontFamily: "monospace", fontSize: 12 }}>{getTxnId(order)}</td>
                      <td>{getCustomerName(order)}</td>
                      <td><span style={{ fontSize: 12 }}>{getMethod(order)}</span></td>
                      <td style={{ textAlign: "right" }}>{getItems(order)}</td>
                      <td style={{ textAlign: "right", fontWeight: 700 }}>{fmt(getAmount(order))}</td>
                      <td>{statusBadge(getStatus(order))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="ts-pag">
              <div className="ts-pag__info">{filteredTxn.length === 0 ? "0" : <>Mostrando <b>{(page - 1) * rpp + 1}</b>-<b>{Math.min(page * rpp, filteredTxn.length)}</b> de <b>{filteredTxn.length}</b></>}</div>
              <div className="ts-pag__pages">
                <button className="ts-page-btn" disabled={page <= 1} onClick={() => setPage((p) => p - 1)} type="button"><I.ChevLeft /></button>
                {pageNumbers().map((p, i) => p === "..." ? <span key={`e${i}`} className="ts-pag__ellipsis">...</span> : <button key={p} className={`ts-page-btn ${page === p ? "ts-page-btn--active" : ""}`} onClick={() => setPage(p)} type="button">{p}</button>)}
                <button className="ts-page-btn" disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)} type="button"><I.ChevRight /></button>
              </div>
            </div>
          </div>

          <div className="ts-section">
            <div className="ts-section__head">
              <div className="ts-section__title"><I.RotateCcw /> Desc. / Devoluciones</div>
              <select className="ts-filter-select" value={rType} onChange={(e) => setRType(e.target.value)}>
                <option>Todos</option>
                <option>Devolucion</option>
                <option>Descuento</option>
              </select>
            </div>
            <div className="ts-filter-row">
              <div className="ts-search-wrap" style={{ maxWidth: "100%" }}>
                <div className="ts-search-icon"><I.Search s={13} /></div>
                <input className="ts-search-input" placeholder="Buscar..." value={rSearch} onChange={(e) => setRSearch(e.target.value)} />
              </div>
            </div>
            <div className="ts-ret-list">
              {filteredRet.length === 0 ? (
                <div className="ts-empty"><div className="ts-empty__icon"><I.RotateCcw /></div><div className="ts-empty__title">Vacio</div><div className="ts-empty__desc">No hay transacciones</div></div>
              ) : filteredRet.map((order) => {
                const type = getRequestType(order);
                return (
                  <div key={order?._id || order?.code || getTxnId(order)} className="ts-ret-item" onClick={() => onOpenReturn?.(order, type)}>
                    <div className={`ts-ret-icon ${type === "Devolucion" ? "ts-ret-icon--return" : "ts-ret-icon--discount"}`}>
                      {type === "Devolucion" ? <I.RotateCcw /> : <I.ArrowDownLeft />}
                    </div>
                    <div className="ts-ret-info">
                      <div className="ts-ret-top">
                        <div><span className="ts-ret-id">Orden: #{getTxnId(order)}</span>{requestBadge(type)}</div>
                        <span className="ts-ret-amount">-{fmt(getAmount(order))}</span>
                      </div>
                      <div className="ts-ret-meta">
                        <span>{getCustomerName(order)}</span><span>·</span><span>{order?.machine_name || order?.user?.name || "Solicitud"}</span><span>·</span><span>{getTime(order)}</span>
                      </div>
                      <div style={{ fontSize: 11, color: "#9090A0", marginTop: 3 }}>Sucursal: {getBranchName(order)} · Solicitud: {getTempCode(order) || "-"}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="ts-ret-footer">
              <span>{filteredRet.length} registro{filteredRet.length !== 1 ? "s" : ""}</span>
              <strong>-{fmt(totalReturns)}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
